<template>
	<div class="modal add-member-modal" style="display: block">
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<button class="no-fill-btns" @click="$emit('close')">
						Cancel
					</button>
					<h4 class="title-modal">Add A Member</h4>
				</div>
				<div class="modal-body">
					<div v-if="isLoading" class="loading-container">
						<loading :active.sync="isLoading" :is-full-page="false" />
					</div>
					<section v-else class="user-manage-form">
						<div class="group user-details">
							<div class="wrapper">
								<label for="firstName" class="label">First name</label>
								<input
									type="text"
									name="firstName"
									class="input"
									placeholder="First Name"
								/>
							</div>
							<div class="wrapper">
								<label for="lastName" class="label">Last name</label>
								<input
									type="text"
									name="lastName"
									class="input"
									placeholder="Last Name"
								/>
							</div>
							<div class="wrapper">
								<label for="email" class="label">Email address</label>
								<input
									type="text"
									name="email"
									class="input"
									placeholder="Email address"
								/>
							</div>
						</div>
						<div class="group">
							<div class="wrapper">
								<label for="role" class="label">Role</label>
								<button class="role-button">
									<span>Basic User</span>
									<font-awesome-icon :icon="['fas', 'chevron-right']" />
								</button>
							</div>
						</div>
						<div class="group">
							<div class="wrapper">
								<label for="status" class="label">Status</label>
								<button class="status-button">
									<span>Active</span>
									<font-awesome-icon :icon="['fas', 'chevron-right']" />
								</button>
							</div>
						</div>
					</section>
				</div>
				<div class="modal-footer">
					<button class="theme-fill-btns" @click="handleSubmitAddMember">
						Register
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
	data() {
		return {
			isLoading: false
		};
	},
	components: {
		Loading
	},
	mounted() {
		const [inputToFocus] = document.getElementsByName("firstName");
		inputToFocus.focus();
	},
	methods: {
		async handleSubmitAddMember() {
			try {
				this.isLoading = true;
				await this.waitTwoMinutes();
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
				this.$emit("close");
				this.$emit("insertNewUser");
			}
		},
		waitTwoMinutes() {
			return new Promise((resolve, reject) =>
				setTimeout(() => {
					return Math.random() > 0.5 ? resolve() : reject();
				}, 2000)
			);
		}
	}
};
</script>
